export default __webpack_public_path__ + "static/media/bank-account.2f9df226.svg";